/** Parse YYYY-MM-DD as local calendar date (avoids UTC shift). */
export function toLocalDate(iso) {
  const [y, m, d] = String(iso || '').slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

/** Today at local midnight. */
export function startOfToday() {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
}

/**
 * Still running or upcoming (not finished).
 * Example: today May 1, event Apr 29–May 5 → included.
 */
export function isUpcomingOrLive(event, today = startOfToday()) {
  const end = toLocalDate(event.endDate || event.startDate);
  if (!end) return false;
  return end >= today;
}

/** Today falls within start–end inclusive. */
export function isEventLive(event, today = startOfToday()) {
  const start = toLocalDate(event.startDate);
  const end = toLocalDate(event.endDate || event.startDate);
  if (!start || !end) return false;
  return today >= start && today <= end;
}

export function formatEventDateRange(event) {
  const start = toLocalDate(event.startDate);
  const end = toLocalDate(event.endDate || event.startDate);
  if (!start) return '';
  const opts = { month: 'short', day: 'numeric' };
  if (!end || event.startDate === event.endDate) {
    return start.toLocaleDateString('en-US', opts);
  }
  if (start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear()) {
    return `${start.toLocaleDateString('en-US', { month: 'short' })} ${start.getDate()}-${end.getDate()}`;
  }
  return `${start.toLocaleDateString('en-US', opts)}-${end.toLocaleDateString('en-US', opts)}`;
}

export function formatEventDuration(event) {
  const start = toLocalDate(event.startDate);
  const end = toLocalDate(event.endDate || event.startDate);
  if (!start || !end) return event.time || '';
  const days = Math.round((end - start) / 86400000) + 1;
  if (days <= 1) return event.time || 'Full Day';
  return `${days} Days`;
}

/** Upcoming/live events sorted: live first, then by start date. */
export function getUpcomingEvents(events, limit = 3) {
  const today = startOfToday();
  return (events || [])
    .filter((e) => isUpcomingOrLive(e, today))
    .map((e) => ({ ...e, isLive: isEventLive(e, today) }))
    .sort((a, b) => {
      if (a.isLive !== b.isLive) return a.isLive ? -1 : 1;
      return String(a.startDate || '').localeCompare(String(b.startDate || ''));
    })
    .slice(0, limit);
}
